<template>
  <div class="list-collaborator">
    <div>
      <PageTitle
        isBack="true"
        link="rh"
        fontSize="25"
        icon="fa fa-university"
        title="Recursos Humanos // Gerenciamento de Despesas"
      />
    </div>
    <div class="container-especific">
      <section class="separate">
        <h1 class="title"></h1>
      </section>
      <div class="filters-date">
        <div class="moth">
          <span class="mes">Mês:</span>
          <b-form-select
            id="selectedMoth"
            @input="changeMoth"
            class="selected-moth"
            :options="months"
            v-model="currentMoth"
          ></b-form-select>
        </div>
        <div class="width-space-date"></div>
        <div class="year">
          <span class="ano">Ano:</span>
          <b-form-input
            id="inputAno"
            @blur.native="changeMoth"
            class="input-year rigth-especific"
            type="text"
            v-mask="dateYear"
            v-model="ano"
          ></b-form-input>
        </div>
      </div>
      <section class="separate">
        <h1 class="title"></h1>
      </section>

      <div class="flex-filters-and-collaborators">
        <div class="filters-and-buttons">
          <div class="butons">
            <div>
              <b-button
                @click="clickPrintSelecteds"
                variant="info"
                class="mr-2 btn-send"
                >Imprimir Selecionados</b-button
              >
            </div>
            <div class="height-space"></div>
          </div>
          <div class="height-space"></div>
          <div class="height-space"></div>
          <div class="selected-grup">
            <vs-select
              placeholder="Selecione..."
              label="Tipo funcionário"
              label-placeholder="Autocomplete"
              autocomplete
              v-model="obreiroSelecionado"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in comboObreiro"
              />
            </vs-select>
          </div>
          <div class="height-space"></div>
          <div class="selected-grup">
            <vs-select
              placeholder="Selecione..."
              label="Envio"
              label-placeholder="Autocomplete"
              autocomplete
              v-model="envioSelecionado"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in comboEnviado"
              />
            </vs-select>
          </div>
          <div class="height-space"></div>
          <div class="selected-grup">
            <vs-select
              placeholder="Selecione..."
              label="Aprovação"
              label-placeholder="Autocomplete"
              autocomplete
              v-model="aprovadoSelecionado"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.label"
                v-for="(item, index) in comboAprovado"
              />
            </vs-select>
          </div>
          <div class="height-space"></div>
          <div class="selected-grup">
            <vs-select
              placeholder="Selecione..."
              label="Nivel"
              label-placeholder="Autocomplete"
              multiple
              autocomplete
              v-model="niveisSelecionados"
              @input="niveisSelecteds"
            >
              <vs-select-item
                :key="index"
                :value="item.nivel"
                :text="item.nivel"
                v-for="(item, index) in niveis"
              />
            </vs-select>
          </div>
          <div class="height-space"></div>
          <b-button @click="clickFilter" variant="success" class="mr-2 btn-send"
            >Filtrar</b-button
          >
        </div>
        <div class="width-space"></div>
        <div class="height-space"></div>
        <div class="height-space"></div>
        <div class="collaborators">
          <Collaborator
            :collaborators="collaborators"
            :currentMoth="currentMoth"
            :ano="ano"
            @getCollaboratorSelected="getCollaboratorSelected($event)"
            @onCloseListCollaborator="onClose($event)"
            @onClosedListExpensesTotal="onClosedListExpensesTotal($event)"
            @onAprove="onAprove($event)"
            @onDesaprove="onDesaprove($event)"
          />
        </div>
      </div>
    </div>
    <AproveSelected
      :collaboratorSelected="collaboratorSelected"
      :yearMonthCurrent="getYearMonthCurrent()"
      @closeAproveSelected="onClose($event)"
    />

    <!-- poupap de print dos relatórios -->
    <vs-popup
      fullscreen
      title="Relatorio de despesas"
      :active.sync="popupActivoPrint"
    >
      <div class="content-modal">
        <div v-show="loadingImport" style="width: 100%; text-align: center">
          <img src="@/assets/loading-image.gif" />
        </div>
        <div v-show="!loadingImport">
          <iframe
            id="frame"
            style="width: 100%; height: 85vh"
            :src="linkPrint + '?no-cache=' + Math.random()"
          ></iframe>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { baseApiUrlRH, baseApiUrlReports } from "@/global";
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

import PageTitle from "@/components/template/PageTitle";
import PrintReportExpenses from "@/components/modules/rh/Expenses/PrintReportExpenses";
import AproveSelected from "@/components/modules/rh/Expenses/AproveSelected";
import Collaborator from "@/components/modules/rh/Expenses/ListCollaborator";

var configMessage = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 3000,
};

export default {
  name: "ListCollaborator",
  components: {
    PageTitle,
    PrintReportExpenses,
    AproveSelected,
    Collaborator,
  },
  data() {
    return {
      loadingImport: false,
      popupActivoPrint: false,
      linkPrint: "",
      niveis: [],
      niveisSelecionados: [],
      obreiroSelecionado: 0,
      comboObreiro: [
        { value: 0, label: "Todos" },
        { value: 2, label: "Obreiro" },
        { value: 1, label: "Não Obreiro" },
      ],
      envioSelecionado: 0,
      comboEnviado: [
        { value: 0, label: "Todos" },
        { value: 1, label: "Enviados" },
        { value: 2, label: "Não Enviados" },
      ],
      aprovadoSelecionado: 0,
      comboAprovado: [
        { value: 0, label: "Todos" },
        { value: 1, label: "Aprovados" },
        { value: 2, label: "Não Aprovados" },
      ],
      collaborators: [],
      collaboratorSelected: [],
      filtersCollaborators: [],
      filter: null,
      months: [
        { text: "Janeiro	  ", value: 0 },
        { text: "Fevereiro  ", value: 1 },
        { text: "Março	  ", value: 2 },
        { text: "Abril	  ", value: 3 },
        { text: "Maio	      ", value: 4 },
        { text: "Junho	  ", value: 5 },
        { text: "Julho	  ", value: 6 },
        { text: "Agosto	  ", value: 7 },
        { text: "Setembro   ", value: 8 },
        { text: "Outubro	  ", value: 9 },
        { text: "Novembro   ", value: 10 },
        { text: "Dezembro   ", value: 11 },
      ],
      dateYear: "####",
      anoMes: "",
      currentMoth: new Date().getMonth(),
      ano: new Date().getFullYear(),
      checkbox: [],
      sends: false,
      aproveds: false,
      nosends: false,
      noaproveds: false,
      obreiro: false,
      noobreiro: false,
      checked: true,
      checkedSends: false,
      checkedAproveds: false,
      checkedNoSends: false,
      checkedNoAproveds: false,
      checkedObreiro: false,
      checkedNoObreiro: false,
      filterGrups: "00",
      diaLimit: null,
      isAlreadyClosed: false,
    };
  },

  mounted() {
    // this.$vs.loading();
    // this.getDate();
    this.listBenefits(this.getDate(), "00");
    this.listNiveis();
    // this.$vs.loading.close();
  },

  methods: {
    onClosedListExpensesTotal(evt) {
      evt.collaboratorSelected.value = evt.total;
    },
    onAprove(evt) {
      evt.collaboratorSelected.aprove = evt.aprove;
      evt.collaboratorSelected.send = evt.aprove;
    },
    onDesaprove(evt) {
      evt.collaboratorSelected.aprove = evt.desaprove;
    },
    async clickPrintSelecteds() {
      this.$vs.loading({ text: "Imprimindo relatório..." });

      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      var dateBenefits =
        this.ano +
        "-" +
        m +
        "-" +
        ((this.diaLimit + "").length > 1 ? this.diaLimit : "0" + this.diaLimit);
      if (this.collaboratorSelected.length < 1) {
        this.loadingImport = false;
        this.showMessage(
          "Selecione um colaborador para gerar os Relatório de Despesa",
          "danger"
        );
        return;
      }
 
      await axios(
        `${baseApiUrlReports}/print/benefits/${dateBenefits}/${this.getBase64Encode()}/${false}`,
        {
          method: "GET",
          responseType: "blob", //Force to receive data in a Blob Format
        }
      )
        .then((resp) => {
          const file = new Blob([resp.data], { type: "application/pdf" });
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        })
        .catch(() => {
          this.$toasted.show(
            "Não foi possível imprimir o relatório, contacte o administrador do sistema" +
              error,
            configMessage
          );
          this.$vs.loading.close();
        });

      this.$vs.loading.close();
    },

    clickAproveSelecteds() {
      this.showMessage(
        "Em manutenção por favor utilize a aprovação um a um.",
        "danger"
      );
      // EventBusExpenses.$emit("popupActivoAproveSelected", true);
    },

    getCollaboratorSelected(evt) {
      this.collaboratorSelected = [];
      // this.collaboratorSelected = evt;
      //remove duplicidade
      // console.log(evt);

      this.collaboratorSelected = this.eliminarObjetosDuplicados(evt, "id");
      // console.log(this.collaboratorSelected);
    },

    eliminarObjetosDuplicados(arr, prop) {
      var nuevoArray = [];
      var lookup = {};

      for (var i in arr) {
        lookup[arr[i][prop]] = arr[i];
      }

      for (i in lookup) {
        nuevoArray.push(lookup[i]);
      }

      return nuevoArray;
    },

    onClose(evt) {
      // this.$vs.loading();
      // setTimeout(() => {
      // this.listBenefits(this.getYearMonthCurrent(), this.filterGrups);
      // }, 2000);
      // this.$vs.loading.close();
    },

    showMessage(message, type) {
      this.$vs.notify({
        title: "Aviso",
        text: message,
        color: type,
      });
    },

    getBase64EncodeOne(collaboratorId) {
      // return btoa(collaborator);
      // console.log(btoa(collaboratorId));
      return collaboratorId;
    },

    getBase64Encode() {
      // console.log(btoa(collaboratorId));
      let collaboratorIds = "";
      this.collaboratorSelected.forEach((c) => {
        collaboratorIds += "'" + c.id + "',";
      });
      collaboratorIds += ";";
      collaboratorIds = collaboratorIds.replace(",;", "");

      // return btoa(collaboratorIds);
      return encodeURIComponent(collaboratorIds);
    },
    // http://localhost:8082 /print/benefits/2021-12-18/%22001974%22%2C%22001538%22/false

    niveisSelecteds() {
      let vue = this;
      this.filterGrups = "";
      this.niveisSelecionados.forEach((g) => {
        vue.filterGrups += g + ",";
      });
      this.filterGrups += ";";
      this.filterGrups = this.filterGrups.replace(",;", "");
      if (this.niveisSelecionados.length < 1) this.filterGrups = "00";
    },

    clickFilter() {
      this.listBenefits(this.getYearMonthCurrent(), this.filterGrups);
    },

    async listBenefits(anoMes, filterGrups) {
      this.$vs.loading();
      this.collaborators = await axios
        .get(
          `${baseApiUrlRH}/reportbenefits/listCollaborator/${anoMes}/${filterGrups}`
        )
        .then((resp) => resp.data);
      this.filtersCollaborators = this.collaborators;
      this.selecionarFiltroEvents();
      this.alreadyClosed(anoMes);

      this.getDayLimit();
      this.$vs.loading.close();
    },

    async alreadyClosed(anoMes) {
      this.isAlreadyClosed = await axios
        .get(`${baseApiUrlRH}/reportbenefits/alreadyClosed/${anoMes}`)
        .then((resp) => resp.data);
    },

    async getDayLimit() {
      this.diaLimit = await axios
        .get(`${baseApiUrlRH}/reportbenefits/getDiaLimit`)
        .then((resp) => resp.data);
    },
    async listNiveis() {
      // this.$vs.loading();
      this.niveis = await axios
        .get(`${baseApiUrlRH}/reportbenefits/listNiveis`)
        .then((resp) => resp.data);
      // this.$vs.loading.close();
    },

    //filtra por obreiros
    selecionarFiltroEvents() {
      //filtro tipo funcionario
      if (this.obreiroSelecionado == 2) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.obreiro === "2" || elem.obreiro === "3";
        });
      } else if (this.obreiroSelecionado == 1) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.obreiro === "1";
        });
      }

      //filtro de envio
      if (this.envioSelecionado == 1) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.send === true;
        });
      } else if (this.envioSelecionado == 2) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.send === false;
        });
      }

      //filtro aprovação
      if (this.aprovadoSelecionado == 1) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.aprove === true;
        });
      } else if (this.aprovadoSelecionado == 2) {
        this.collaborators = this.collaborators.filter((elem) => {
          return elem.aprove === false;
        });
      }
    },

    getDate() {
      var data = new Date();
      // this.currentMoth = data.getMonth();
      // this.ano = data.getFullYear();
      var m =
        (data.getMonth() + 1 + "").length > 1
          ? data.getMonth() + 1
          : "0" + (data.getMonth() + 1);
      this.anoMes = this.ano + "" + m;
      return this.anoMes;
    },

    getYearMonthCurrent() {
      var m =
        (this.currentMoth + 1 + "").length > 1
          ? this.currentMoth + 1
          : "0" + (this.currentMoth + 1);
      this.anoMes = this.ano + "" + m;
      return this.anoMes;
    },

    changeMoth() {
      let anoMes = this.getYearMonthCurrent();
      this.listBenefits(anoMes, this.filterGrups);
    },
    changeYear() {
      var data = new Date();
      this.currentMoth = data.getMonth();
      var m =
        (data.getMonth() + 1 + "").length > 1
          ? data.getMonth() + 1
          : "0" + (data.getMonth() + 1);
      this.data =
        ((this.diaLimit + "").length > 1
          ? this.diaLimit
          : "0" + this.diaLimit) +
        "/" +
        m +
        "/" +
        this.ano;
    },
  },
};
</script>

<style scoped src="./expenses.css">
</style>
